import Vue from 'vue'
import Router from 'vue-router'
import routes from '@/router/router'

Vue.use(Router)

const createRouter = () => new Router({
  // mode: 'history',
  routes: routes
})

const router = createRouter()
// eslint-disable-next-line
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
  console.log(111)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js